/**
 * @file index.tsx
 *
 * @fileoverview Renders the environment indicator above header.
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box } from '~/vcl/atoms/07-box';
import { Text } from '~/vcl/atoms/13-text/03-text';

export default function HeaderEnvironmentIndicator() {
  // Get staging and NODE_ENV variables to check and show correct env indicator.
  const staging = process.env.staging;
  const nodeEnv = process.env.NODE_ENV;

  return nodeEnv == 'development' ? (
    <Box
      backgroundColor="success"
      marginClean={true}
      padding={3}
      borderRadius="0"
    >
      <Text color="white" textAlign="center" margin="0">
        <FormattedMessage
          id="env_indicator_development"
          defaultMessage="Development environment"
        />
      </Text>
    </Box>
  ) : staging ? (
    <Box
      backgroundColor="warning"
      marginClean={true}
      padding={3}
      borderRadius="0"
    >
      <Text color="black" textAlign="center" margin="0">
        <FormattedMessage
          id="env_indicator_staging"
          defaultMessage="Staging environment"
        />
      </Text>
    </Box>
  ) : null;
}
